import { buildStructuredIdentity } from "@/features/identity/buildStructuredIdentity";

// Fictional demo identity for the landing showcase only.
const DEMO_PROFILE = {
  full_name: "Alex Morgan",
  professional_title: "Business Development Director",
  company_name: "Vertex Consulting",
  email: "alex.morgan@vertexconsulting.demo",
  phone: "+974 0000 0000",
  website: "https://vertexconsulting.demo",
  bio: "Building long-term partnerships across the Gulf region, connecting growing companies with the advisors they need.",
  profile_photo_url: "/demo/alex-morgan.jpg",
  company_logo_url: "/demo/vertex-logo.svg",
};

const DEMO_LINKS = [
  { platform: "linkedin", url: "https://www.linkedin.com/in/alex-morgan-demo", is_visible: true, display_order: 0 },
  { platform: "instagram", url: "https://www.instagram.com/alexmorgan.demo", is_visible: true, display_order: 1 },
  { platform: "x", url: "https://x.com/alexmorgan_demo", is_visible: true, display_order: 2 },
];

export const DEMO_IDENTITY = buildStructuredIdentity(DEMO_PROFILE, DEMO_LINKS, { canonicalUrl: "https://getmetworthapp.com" });
